import { render, staticRenderFns } from "./GalleryImage.vue?vue&type=template&id=6a366f8d&"
import script from "./GalleryImage.vue?vue&type=script&lang=js&"
export * from "./GalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./GalleryImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports